// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1lQOW","productName":"Table_productName__37PXq"};